<button class="td-wb-overlay__close-button"
        id="overlayCloseButton"
        [attr.aria-label]="'tdWb.overlay.CLOSE_ARIA' | tdWbTranslate"
        tdWbIconButton
        tdWbIconButtonBackground="clear-grey"
        tdWbIconButtonSize="extra-small"
        tdWbIconButtonShape="circle"
        (click)="close()">
  <td-wb-icon iconId="close--small"
              size="12" />
</button>
<ng-content />

